<script>
import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    isKudo: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: [Array, Object],
      default: () => ({}),
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    redirectPath: {
      type: Object,
      required: false,
      default: null,
    },
    dateTime: {
      type: Object,
      required: false,
      default: () => ({
        after: null,
        before: null,
        range: null,
      }),
    },
  },
  mounted() {
    const data = this.processChartData(this.chartData);

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: this.title ? true : false,
        text: this.title,
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            const label = data.labels[tooltipItem.index];
            const value = data.datasets[0].data[tooltipItem.index];
            const total = data.datasets[0].data.reduce(
              (sum, num) => sum + num,
              0
            );
            const percentage = ((value / total) * 100).toFixed(2);
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
      legend: {
        onClick: (e) => e.stopPropagation(),
      },
      onClick: this.handleClick,
    };

    this.renderChart(data, options);
  },
  methods: {
    processChartData(chartData) {
      return chartData;
    },
    handleClick(event, items) {
      if (this.isKudo) {
        return;
      }
      if (items.length > 0) {
        const clickedData = this.chartData.labels[items[0]._index];
        this.goToReport(clickedData);
      }
    },
    replaceString(input, replacements) {
      for (const [key, value] of Object.entries(replacements)) {
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        input = input.replace(new RegExp(escapedKey, "g"), value);
      }
      return input;
    },
    goToReport(selectedLabel) {
      if (this.redirectPath) {
        const query = {
          highlight_column: "visitsNumber",
          select_option: selectedLabel,
        };

        if (this.dateTime) {
          if (this.dateTime.range && !this.dateTime.range.includes("custom")) {
            query.range = this.dateTime.range;
          } else if (this.dateTime.after && this.dateTime.before) {
            query.customDate = "true";
            query.range = "custom";
            query.customRange = JSON.stringify({
              start: this.dateTime.after,
              end: this.dateTime.before,
            });
          }
        }

        if (typeof this.redirectPath === "string") {
          this.$router.push({
            name: this.redirectPath,
            query,
          });
        } else {
          this.$router.push({
            ...this.redirectPath,
            query,
          });
        }
      }
    },
  },
};
</script>
